module.exports = __webpack_public_path__ + "media/images/social/social-icon-mail-42b99b87226639788c6f3ff1c7a54b60.svg";